import { forwardRef, type InputHTMLAttributes } from 'react';

import { cn } from '@/shared/utils/cn';

export interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  /** Toggles the error-state styling. Error *message* is rendered by FormField. */
  invalid?: boolean;
}

export const Input = forwardRef<HTMLInputElement, InputProps>(
  ({ className, invalid, ...rest }, ref) => (
    <input
      ref={ref}
      className={cn(
        'flex h-9 w-full items-center rounded-sm border bg-surface px-3 text-sm text-fg shadow-sm',
        'placeholder:text-fg-subtle',
        'focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-1',
        'disabled:cursor-not-allowed disabled:bg-surface-muted disabled:text-fg-muted',
        invalid
          ? 'border-danger-strong focus-visible:ring-danger'
          : 'border-border-strong focus-visible:ring-primary',
        className,
      )}
      aria-invalid={invalid || undefined}
      {...rest}
    />
  ),
);

Input.displayName = 'Input';
